/* WCR Design Landing — Autofill from PP map (designnum/slug) + size picker + dual CTAs */
(function () {
  'use strict';

  var CFG = {
    MAP_URL: "/apps/qps-commerce-control-plane/designer/design-landing-pages",
    FOUNDATION_ROUTES_URL: "/apps/qps-commerce-control-plane/designer/legacy-design-template-routes",
    // Brand only used for SEO text in other snippets; keep available here if needed downstream
    BRAND: "",
    // Pull fallbacks from page metafields (optional; path slug is preferred)
    FALLBACK_ID: "",
    FALLBACK_SLUG: ""
  };

  function qs(sel, root){ return (root||document).querySelector(sel); }
  function qsa(sel, root){ return [].slice.call((root||document).querySelectorAll(sel)); }
  function getParam(name){ var m = new URLSearchParams(window.location.search).get(name); return (m && m.trim().length) ? m.trim() : null; }

  function pickDesign(items){
    // Prefer by slug when using one-page-per-design with matching handle
    var pathSlug = (location.pathname.split('/pages/')[1] || '').split('/')[0] || '';
    var id = getParam('designnum') || (CFG.FALLBACK_ID || '').trim() || null;
    var qpSlug = getParam('design') || (CFG.FALLBACK_SLUG || '').trim() || null;

    if (pathSlug) {
      var byPath = items.find(function(it){ return it.slug === pathSlug; });
      if (byPath) return byPath;
    }
    if (id) {
      var byId = items.find(function(it){ return String(it.id) === String(id); });
      if (byId) return byId;
    }
    if (qpSlug) {
      var bySlug = items.find(function(it){ return it.slug === qpSlug; });
      if (bySlug) return bySlug;
    }
    return null;
  }

  function readDesignNumberFromUrl(value){
    if (!value) return '';
    try {
      var parsed = new URL(value, window.location.origin);
      return (parsed.searchParams.get('designnum') || '').trim();
    } catch (err) {
      return '';
    }
  }

  function collectDesignNumbers(data){
    var seen = {};
    var result = [];
    function add(value){
      var text = String(value || '').trim();
      if (!text || seen[text]) return;
      seen[text] = true;
      result.push(text);
    }
    add(data && data.id);
    if (data && Array.isArray(data.sizes)) {
      data.sizes.forEach(function(size){
        add(readDesignNumberFromUrl(size && size.customize_url));
        add(readDesignNumberFromUrl(size && size.edit_url));
      });
    }
    if (data && data.ctas) {
      add(readDesignNumberFromUrl(data.ctas.primary && data.ctas.primary.url));
      add(readDesignNumberFromUrl(data.ctas.edit && data.ctas.edit.url));
    }
    return result;
  }

  function normalizeFoundationRouteMap(payload){
    var routeMap = {};
    var source = payload && payload.routesByDesignNumber;
    if (source && typeof source === 'object') {
      Object.keys(source).forEach(function(key){
        var item = source[key];
        if (item && item.designNumber) routeMap[String(item.designNumber)] = item;
      });
    }
    if (payload && Array.isArray(payload.items)) {
      payload.items.forEach(function(item){
        if (item && item.designNumber && !routeMap[String(item.designNumber)]) {
          routeMap[String(item.designNumber)] = item;
        }
      });
    }
    return routeMap;
  }

  function buildFoundationDesignUrl(originalUrl, route){
    var originalDesignNumber = readDesignNumberFromUrl(originalUrl);
    if (!originalUrl || !originalDesignNumber) {
      return originalUrl || '';
    }
    if (!route || !route.designNumber || !route.legacyDesignId || !route.productUrl) {
      return '';
    }
    try {
      var original = new URL(originalUrl, window.location.origin);
      var product = new URL(route.productUrl, window.location.origin);
      var params = new URLSearchParams(original.search);
      params.set('id', String(route.legacyDesignId));
      params.set('designnum', String(route.designNumber));
      product.search = params.toString();
      product.hash = original.hash || product.hash || '';
      if (product.origin === window.location.origin) {
        return product.pathname + product.search + product.hash;
      }
      return product.toString();
    } catch (err) {
      return '';
    }
  }

  function disableDesignLandingCtas(data, reason){
    if (!data) return data;
    data.__foundationRouteError = reason || 'foundation_route_unavailable';
    if (Array.isArray(data.sizes)) {
      data.sizes.forEach(function(size){
        if (!size) return;
        size.customize_url = '';
        size.edit_url = '';
      });
    }
    if (data.ctas && data.ctas.primary) data.ctas.primary.url = '';
    if (data.ctas && data.ctas.edit) data.ctas.edit.url = '';
    return data;
  }

  function applyFoundationUrl(originalUrl, routeMap, missingRoutes){
    var designNumber = readDesignNumberFromUrl(originalUrl);
    if (!originalUrl || !designNumber) return originalUrl || '';
    var resolved = buildFoundationDesignUrl(originalUrl, routeMap[designNumber]);
    if (!resolved) missingRoutes.push(designNumber);
    return resolved;
  }

  function applyFoundationRoutes(data, payload){
    var routeMap = normalizeFoundationRouteMap(payload);
    var missingRoutes = [];
    if (!data) return data;
    if (Array.isArray(data.sizes)) {
      data.sizes.forEach(function(size){
        if (!size) return;
        size.customize_url = applyFoundationUrl(size.customize_url, routeMap, missingRoutes);
        size.edit_url = applyFoundationUrl(size.edit_url, routeMap, missingRoutes);
      });
    }
    if (data.ctas && data.ctas.primary) {
      data.ctas.primary.url = applyFoundationUrl(data.ctas.primary.url, routeMap, missingRoutes);
    }
    if (data.ctas && data.ctas.edit) {
      data.ctas.edit.url = applyFoundationUrl(data.ctas.edit.url, routeMap, missingRoutes);
    }
    if (missingRoutes.length) {
      return disableDesignLandingCtas(data, 'missing_foundation_routes:' + missingRoutes.join(','));
    }
    data.__foundationRoutesResolved = true;
    return data;
  }

  function loadFoundationRoutes(data){
    var designNumbers = collectDesignNumbers(data);
    if (!designNumbers.length) return Promise.resolve(disableDesignLandingCtas(data, 'missing_design_number'));
    var url = CFG.FOUNDATION_ROUTES_URL + '?designNumbers=' + encodeURIComponent(designNumbers.join(','));
    return fetch(url, { credentials: 'same-origin', headers: { 'accept': 'application/json' } })
      .then(function(r){
        if (!r.ok) throw new Error('Foundation route resolver returned ' + r.status);
        return r.json();
      })
      .then(function(payload){
        return applyFoundationRoutes(data, payload);
      })
      .catch(function(err){
        console.warn('[DLP] Foundation route resolver unavailable; disabling design CTAs', err);
        return disableDesignLandingCtas(data, 'foundation_route_resolver_unavailable');
      });
  }

  function setTextAll(attr, value){
    qsa('[data-dlp="'+attr+'"]').forEach(function(n){ if (n) n.textContent = value || ''; });
  }

  function setLinkUrl(node, url){
    if (!node) return;
    var value = String(url || '').trim();
    if (value) {
      node.setAttribute('href', value);
      node.removeAttribute('aria-disabled');
      node.removeAttribute('role');
      node.removeAttribute('title');
      node.classList.remove('dlp-btn--disabled');
      node.style.pointerEvents = '';
      node.style.opacity = '';
      node.style.cursor = '';
      return;
    }
    node.removeAttribute('href');
    node.setAttribute('role', 'link');
    node.setAttribute('aria-disabled', 'true');
    node.setAttribute('title', 'Template routing is unavailable');
    node.classList.add('dlp-btn--disabled');
    node.style.pointerEvents = 'none';
    node.style.opacity = '0.55';
    node.style.cursor = 'not-allowed';
  }

  function renderHero(data){
    setTextAll('design_name', data.name);
    setTextAll('subtitle', data.subtitle || '');

    var img = qs('[data-dlp="hero_img"]');
    if (img && data.hero && (data.hero.src || img.getAttribute('src'))) {
      if (data.hero.src) {
        img.setAttribute('src', data.hero.src);
        img.setAttribute('srcset', data.hero.src + ' 1600w');
      }
      if (data.hero.alt) img.setAttribute('alt', data.hero.alt);
      var cap = qs('[data-dlp="hero_caption"]');
      if (cap && data.hero.caption) cap.textContent = data.hero.caption;
    }

    var sec = qs('[data-dlp="cta_secondary"]');
    if (sec && data.ctas && data.ctas.secondary) {
      setLinkUrl(sec, data.ctas.secondary.url);
      sec.textContent = data.ctas.secondary.label || 'View Other Templates →';
    }

    // Dual CTAs + size picker
    var customizeBtn = qs('[data-dlp="cta_customize"]');
    var editBtn = qs('[data-dlp="cta_edit"]');
    var sizeRow = document.getElementById('dlp-size-row');
    var sizeSelect = qs('[data-dlp="size_select"]');
    setLinkUrl(customizeBtn, '');
    setLinkUrl(editBtn, '');

    function applyForIndex(i){
      var s = data.sizes && data.sizes[i];
      if (!s) return;
      setLinkUrl(customizeBtn, s.customize_url);
      setLinkUrl(editBtn, s.edit_url);
    }

    if (Array.isArray(data.sizes) && data.sizes.length) {
      // Default to first size
      applyForIndex(0);

      if (data.sizes.length > 1 && sizeRow && sizeSelect) {
        sizeRow.style.display = 'flex';
        sizeSelect.innerHTML = data.sizes.map(function(s, i){
          var lbl = s.label || ('Option ' + (i+1));
          return '<option value="'+i+'">'+lbl+'</option>';
        }).join('');
        sizeSelect.addEventListener('change', function(){
          var idx = parseInt(sizeSelect.value, 10) || 0;
          applyForIndex(idx);
        });
      }
    } else {
      // No sizes; still try to apply direct CTAs from ctas.primary if provided
      if (data.ctas && data.ctas.primary) {
        setLinkUrl(customizeBtn, data.ctas.primary.url);
      }
      if (data.ctas && data.ctas.edit) {
        setLinkUrl(editBtn, data.ctas.edit.url);
      }
    }
  }

  function renderGallery(data){
    var host = qs('#dlp-gallery-auto');
    if (!host || !data.gallery || !data.gallery.length) return;
    host.innerHTML = '';
    data.gallery.forEach(function(g){
      var fig = document.createElement('figure');
      fig.style.margin = '0';
      fig.innerHTML = '<img loading="lazy" decoding="async" style="width:100%;height:auto;border-radius:8px;">'
                    + (g.caption ? '<figcaption style="font-size:12px;color:#666;margin-top:6px;"></figcaption>' : '');
      var img = fig.querySelector('img');
      if (g.src) img.src = g.src;
      if (g.alt) img.alt = g.alt;
      if (g.caption) fig.querySelector('figcaption').textContent = g.caption;
      host.appendChild(fig);
    });
  }

  function renderAboutBody(data){
    var host = qs('[data-dlp="about_body"]');
    if (!host) return;
    if (data.about_html && typeof data.about_html === 'string') {
      host.innerHTML = data.about_html;
      return;
    }
    if (data.subtitle) {
      host.innerHTML = '<p>' + escapeHTML(data.subtitle) + '</p>';
    }
  }

  function renderCTAstrip(data){
    var heading = qs('[data-dlp="cta_heading"]');
    if (heading) {
      var txt = (data.cta_heading || 'Ready to customize this design?');
      heading.textContent = txt;
    }
    var pri = qs('[data-dlp="cta_strip_primary"]');
    if (pri) {
      var primaryUrl = null;
      if (data.ctas && data.ctas.primary && data.ctas.primary.url) {
        primaryUrl = data.ctas.primary.url;
      } else if (Array.isArray(data.sizes) && data.sizes.length && data.sizes[0].customize_url) {
        primaryUrl = data.sizes[0].customize_url;
      }
      setLinkUrl(pri, primaryUrl);
      if (data.ctas && data.ctas.primary && data.ctas.primary.label) {
        pri.textContent = data.ctas.primary.label;
      }
    }
    var sec = qs('[data-dlp="cta_strip_secondary"]');
    if (sec && data.ctas && data.ctas.secondary) {
      setLinkUrl(sec, data.ctas.secondary.url);
      if (data.ctas.secondary.label) sec.textContent = data.ctas.secondary.label;
    }
  }

  function renderCopyAudiences(data){
    if (Array.isArray(data.audiences) && data.audiences.length){
      var list = qs('[data-dlp="audiences"]');
      if (list) {
        list.innerHTML = '';
        data.audiences.forEach(function(t){
          var li = document.createElement('li'); li.textContent = t; list.appendChild(li);
        });
      }
    }
  }

  function renderSpecs(data){
    var tableBody = qs('[data-dlp="specs"]');
    if (!tableBody || !data.specs) return;
    tableBody.innerHTML = '';
    Object.keys(data.specs).forEach(function(label){
      var val = data.specs[label];
      var row = document.createElement('div');
      row.setAttribute('role','row');
      row.style.cssText = 'display:grid;grid-template-columns:190px 1fr;gap:0;border-top:1px solid #e5e5e5;';
      row.innerHTML = '<div role="cell" style="background:#fafafa;padding:10px 12px;font-weight:600;"></div>'
                    + '<div role="cell" style="padding:10px 12px;"></div>';
      row.children[0].textContent = label;
      row.children[1].textContent = val;
      tableBody.appendChild(row);
    });
  }

  function renderFAQ(data){
    var host = qs('[data-dlp="faq"]');
    if (!host || !Array.isArray(data.faq)) return;
    host.innerHTML = '';
    data.faq.forEach(function(qa){
      var details = document.createElement('details');
      details.style.cssText = 'border:1px solid #e5e5e5;border-radius:8px;padding:12px;margin:10px 0;';
      details.innerHTML = '<summary style="cursor:pointer;font-weight:700;"></summary><div style="margin-top:8px;"></div>';
      details.querySelector('summary').textContent = qa.q;
      details.querySelector('div').textContent = qa.a;
      host.appendChild(details);
    });
  }

  function renderFAQTitle(data){
    var h2 = qs('[data-dlp="faq_title"]');
    if (!h2) return;
    var base = data.faq_title || (data.name ? data.name : 'This Design');
    if (base && base.toLowerCase().indexOf('faq') === -1) {
      h2.textContent = 'FAQ – ' + base;
    } else if (base) {
      h2.textContent = base;
    }
  }

  function injectJSONLD_Product(data){
    qsa('script[type="application/ld+json"].dlp-product').forEach(function(s){ s.remove(); });
    var script = document.createElement('script');
    script.type = 'application/ld+json';
    script.className = 'dlp-product';
    var json = {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": data.name,
      "description": data.subtitle || "Customizable service business sign template.",
      "image": (data.hero && data.hero.src) ? data.hero.src : undefined,
      "brand": { "@type": "Brand", "name": CFG.BRAND || "WCR Marketing" },
      "category": "Business & Industrial > Signage",
      "offers": {
        "@type": "Offer",
        "url": window.location.origin + window.location.pathname + window.location.search,
        "priceCurrency": "USD",
        "availability": "https://schema.org/InStock"
      }
    };
    script.textContent = JSON.stringify(json);
    document.head.appendChild(script);
  }

  function injectJSONLD_FAQ(data){
    qsa('script[type="application/ld+json"].dlp-faq').forEach(function(s){ s.remove(); });
    if (!Array.isArray(data.faq) || !data.faq.length) return;
    var script = document.createElement('script');
    script.type = 'application/ld+json';
    script.className = 'dlp-faq';
    var json = {
      "@context":"https://schema.org",
      "@type":"FAQPage",
      "mainEntity": data.faq.map(function(qa){
        return {
          "@type":"Question",
          "name": qa.q,
          "acceptedAnswer": { "@type":"Answer", "text": qa.a }
        };
      })
    };
    script.textContent = JSON.stringify(json);
    document.head.appendChild(script);
  }

  function go(){
    fetch(CFG.MAP_URL, { credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(map){
        var items = (map && Array.isArray(map.items)) ? map.items : [];
        var data = pickDesign(items);
        if (!data) {
          document.body.classList.add('dlp-ready');
          return;
        }
        return loadFoundationRoutes(data).then(function(resolvedData){
          data = resolvedData || data;
          renderHero(data);
          renderGallery(data);
          renderAboutBody(data);
          renderCopyAudiences(data);
          renderSpecs(data);
          renderFAQ(data);
          renderFAQTitle(data);
          renderCTAstrip(data);
          injectJSONLD_Product(data);
          injectJSONLD_FAQ(data);
          document.body.classList.add('dlp-ready');
        });
      })
      .catch(function(err){
        console.warn('[DLP] map fetch failed', err);
        document.body.classList.add('dlp-ready');
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', go);
  } else {
    go();
  }
})();
  function escapeHTML(s){
    if (s == null) return '';
    return String(s)
      .replace(/&/g,'&amp;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;')
      .replace(/'/g,'&#39;');
  }
